var _desc, _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 163,
    viewBox: "0 0 167.01 163.48",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Email sent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Purple envelope with a checkmark, indicating a sign-in link has been sent successfully.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.88,3.73L0,61.11l83.51,51.19,83.51-51.19L95.14,3.73c-6.96-4.97-16.3-4.97-23.26,0Z",
    fill: "#5f11ea"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.72,
    y: 16.17,
    width: 123.58,
    height: 130.36,
    rx: 8,
    ry: 8,
    fill: "#ebe5f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,61.11v82.37C0,149.73,2.87,155.3,7.36,158.97l76.15-46.68L0,61.11Z",
    fill: "#c1b5e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.51,112.29h0S7.36,158.97,7.36,158.97c3.45,2.82,7.85,4.51,12.64,4.51h127.01c2.76,0,5.39-.56,7.78-1.57,1.2-.51,2.33-1.13,3.4-1.84,5.32-3.59,8.82-9.68,8.82-16.58V61.11s-83.51,51.19-83.51,51.19Z",
    fill: "#9979e2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.03,55.25l19.36,19.36c.07.07.2.07.27,0l34.1-34.1",
    fill: "none",
    stroke: "#5f11ea",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.feb8527165a14072b0406605db940662.svg";
export { ForwardRef as ReactComponent };